import { render, staticRenderFns } from "./FlowDesign.vue?vue&type=template&id=6b9cd90b&scoped=true"
import script from "./FlowDesign.vue?vue&type=script&lang=js"
export * from "./FlowDesign.vue?vue&type=script&lang=js"
import style0 from "./FlowDesign.vue?vue&type=style&index=0&id=6b9cd90b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cd90b",
  null
  
)

export default component.exports